import React from 'react';
import { Users, GraduationCap, BookOpen, Award, BoxIcon } from 'lucide-react';
interface Stat {
  icon: BoxIcon;
  value: string;
  label: string;
}
const stats: Stat[] = [{
  icon: Users,
  value: '16K+',
  label: 'Students Enrolled'
}, {
  icon: GraduationCap,
  value: '105+',
  label: 'PHD Professors'
}, {
  icon: BookOpen,
  value: '29+',
  label: 'Programs Offered'
}, {
  icon: Award,
  value: '10+',
  label: 'National Awards'
}];
export function StatsBar() {
  return <section className="relative z-20 -mt-14 px-4 sm:px-6" data-id="element-171">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-172">
        {stats.map(({
        icon: Icon,
        value,
        label
      }) => <div key={label} className="flex flex-col items-center rounded-xl bg-white px-6 py-7 text-center shadow-md ring-1 ring-black/5" data-id="element-173">
            <Icon className="h-8 w-8 text-[#0f2d5c]" strokeWidth={1.75} data-id="element-174" />
            <span className="mt-3 text-3xl font-bold text-[#b63a2f]" data-id="element-175">
              {value}
            </span>
            <span className="mt-1 text-sm text-slate-600" data-id="element-176">{label}</span>
          </div>)}
      </div>
    </section>;
}